import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faSortAmountUp } from "@fortawesome/free-solid-svg-icons"

export const SortAmountUp = (props) => {
  return <FontAwesomeIcon faIcon={faSortAmountUp} {...props} />
}
